import React, { useState, ChangeEvent, FormEvent } from "react";
import CustomModal from "../CustomModal";
import "../CustomModal.css";
import { useGame } from "../../api/copenhunt/v1/copenhunt_rbt_react";

interface FormValues {
  text: string;
}

const BroadcastModal: React.FC<{ gameId: string }> = ({ gameId }) => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const {
    mutators: { broadcast },
  } = useGame({ id: gameId });

  const [formValues, setFormValues] = useState<FormValues>({ text: "" });

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    console.log(name, value);
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    console.log(formValues);
    const { aborted } = await broadcast(formValues);
    if (aborted !== undefined) {
      alert("Oh no! That didn't work!");
      console.log(aborted);
      return;
    }
    setFormValues((prevValues) => ({
      text: "",
    }));
    closeModal();
  };

  return (
    <div>
      <button onClick={openModal}>Broadcast Message</button>
      <CustomModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        onSubmit={handleSubmit}
        title="Broadcast Message"
      >
        <div className="modal-form-group">
          <label>
            Message
            <input
              type="string"
              name="text"
              value={formValues.text}
              onChange={handleChange}
              required
              className="modal-input"
            />
          </label>
        </div>
      </CustomModal>
    </div>
  );
};

export default BroadcastModal;
